/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fas_ProjectsInputs */

const en_fas_projects = /** @type {(inputs: Fas_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAS Projects`)
};

const nl_fas_projects = /** @type {(inputs: Fas_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAS Projecten`)
};

/**
* | output |
* | --- |
* | "FAS Projects" |
*
* @param {Fas_ProjectsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const fas_projects = /** @type {((inputs?: Fas_ProjectsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fas_ProjectsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_fas_projects(inputs)
	return en_fas_projects(inputs)
});